var Y = Object.defineProperty;
var B = (e, t, n) => t in e ? Y(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var T = (e, t, n) => (B(e, typeof t != "symbol" ? t + "" : t, n), n);
import { createContext as E, useState as $, useRef as d, useEffect as m, useCallback as D, useDebugValue as W, useMemo as v, Suspense as F } from "react";
import q from "react-fast-compare";
import { u as Ae } from "./useSubscriptionHandler-D4p0pO3P.js";
import { c as Ye, i as Be, m as We, s as qe, t as Ke } from "./stringUtils-BHpG31cT.js";
import { jsx as h, jsxs as K } from "react/jsx-runtime";
import { Spin as Q, theme as _, List as G } from "antd";
import k from "styled-components";
const b = "_buzzeasy";
function X(e, t, n) {
  b in window || Object.assign(window, { [b]: {} }), Object.assign(window[b], { [e]: { buildId: t, version: n } });
}
const $e = E(void 0), pe = E(void 0), Se = E(void 0);
function we(e, t) {
  const [n, r] = $(void 0), o = d(e);
  return o.current = e, m(
    () => {
      o.current().then(r);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), n;
}
function Z(e) {
  const [t, n] = $(e), r = D(
    (o) => {
      n((i) => {
        const s = typeof o == "function" ? o(i) : o;
        return q(i, s) ? i : s;
      });
    },
    []
  );
  return W(t), v(
    () => [t, r],
    [r, t]
  );
}
function ye(e, t = 1) {
  const n = v(
    () => e ? typeof e == "string" ? new Date(e) : e : /* @__PURE__ */ new Date(),
    [e]
  ), [r, o] = $(j(n));
  return m(
    () => {
      const i = setInterval(
        () => o(j(n)),
        t * 1e3
      );
      return () => clearInterval(i);
    },
    [n, t]
  ), r;
}
function j(e) {
  return Math.floor((Date.now() - e.getTime()) / 1e3);
}
function Ie(e) {
  const [t, n] = $(window.matchMedia(e).matches);
  return m(
    () => {
      const r = window.matchMedia(e);
      n(r.matches);
      const o = (i) => n(i.matches);
      return r.addEventListener("change", o), () => r.removeEventListener("change", o);
    },
    [e]
  ), t;
}
class ee {
  constructor() {
    T(this, "store", {});
  }
  getItem(t) {
    return this.store[t] ?? null;
  }
  setItem(t, n) {
    this.store[t] = n;
  }
}
const x = new ee();
function te(e, t, n) {
  if (!t && n !== void 0 && n !== x)
    throw new Error("Key is required when not using the default inMemoryStorage.");
  const r = d(t), o = d(t ?? ""), i = d(n ?? x);
  if (r.current !== t)
    throw new Error("Changing key is not supported in usePersistedState.");
  if (i.current !== (n ?? x))
    throw new Error("Changing storage type is not supported in usePersistedState.");
  o.current || (o.current = t ?? ne());
  const s = v(
    () => JSON.parse(i.current.getItem(o.current) ?? "null"),
    []
  ), [c, g] = $(s ?? e), f = D(
    (u) => g((l) => {
      const p = typeof u == "function" ? u(l) : u;
      return i.current.setItem(o.current, JSON.stringify(p)), p;
    }),
    []
  );
  return v(
    () => [c, f],
    [c, f]
  );
}
const z = /\((.*):(\d+):(\d+)\)$/, H = /@(.*):(\d+):(\d+)$/;
let U = !0;
function ne() {
  try {
    U && (console.warn("Using usePersistedState without a key might not work on all browsers and is more prone to break."), U = !1);
    const e = new Error();
    if (!e.stack)
      throw new Error("No stack trace found on error object");
    const t = e.stack.split(`
`), n = !t[0].includes("Error"), r = n ? H.exec(t[2]) : z.exec(t[3]);
    if (!r)
      throw new Error(`No match found in stack trace using regex: /${(n ? H : z).source}/.`);
    return `${r[1]}:${r[2]}:${r[3]}`;
  } catch (e) {
    return console.warn(`Unable to generate a unique key for usePersistedState, inMemory persistence will not function.
`, e), Math.floor(Math.random() * 1e6).toString();
  }
}
function ve(e, t, n) {
  const r = d(n);
  r.current = n, m(
    () => e(r.current),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
function be(e, t) {
  const n = d(!1), r = d(e), o = d(t);
  o.current = t, m(
    () => {
      o.current.forEach(([i, { trigger: s, condition: c }]) => {
        s(e) && (!s(r.current) || n.current) && (!c || c(e)) && i();
      }), n.current = !1, r.current = e;
    },
    [e]
  );
}
const xe = Object.freeze({
  customerId: "",
  businessUnitId: null,
  firstName: null,
  middleName: null,
  lastName: null,
  email: null,
  externalId: null,
  phoneNumbers: [],
  externalProfiles: [],
  customFields: [],
  preferredAgentId: null
});
function Me(e) {
  return [e.firstName, e.middleName, e.lastName].filter((t) => !!t).join(" ");
}
function Ce(e) {
  if (e.length === 0)
    return null;
  const t = e.find((n) => n.preferred);
  return t ? t.number : e[0].number;
}
function re(e, t) {
  const n = JSON.stringify(t);
  localStorage.setItem(e, n);
}
function Ee(e, t) {
  const n = localStorage.getItem(e);
  if (n === null)
    return t ?? null;
  try {
    return JSON.parse(n);
  } catch (r) {
    if (console.error(`Error: getItem('${e}') failed because the value cannot be interpreted as a JSON token and there is no defaultValue to fall back to.`), t === void 0)
      throw r;
    return re(e, t), t;
  }
}
function a(e) {
  return e.toString().padStart(2, "0");
}
const y = 60, I = 60 * y, M = 24 * I;
function V(e) {
  const t = { days: 0, hours: 0, minutes: 0, seconds: 0 };
  let n = e;
  return n >= M && (t.days = Math.floor(n / M), n -= t.days * M), n >= I && (t.hours = Math.floor(n / I), n -= t.hours * I), n >= y && (t.minutes = Math.floor(n / y), n -= t.minutes * y), t.seconds = Math.floor(n), t;
}
function De(e) {
  return e.toLocaleDateString();
}
function ke(e) {
  return `${e.getFullYear()}-${a(e.getMonth() + 1)}-${a(e.getDate())}`;
}
function Ne(e) {
  return `${a(e.getDate())}/${a(e.getMonth() + 1)}/${e.getFullYear()}`;
}
function Oe(e) {
  return `${a(e.getMonth() + 1)}/${a(e.getDate())}/${e.getFullYear()}`;
}
function Le(e) {
  return `${e.toLocaleDateString(void 0, { month: "short" })} ${a(e.getDate())}, ${e.getFullYear()}`;
}
function Pe(e) {
  return e.toLocaleTimeString();
}
function Re(e, t) {
  const n = `${a(e.getHours())}:${a(e.getMinutes())}`;
  return t ? `${n}:${a(e.getSeconds())}` : n;
}
function Te(e, t, n) {
  n ?? (n = { am: "AM", pm: "PM" });
  let r = e.getHours(), o = n.am;
  r === 0 ? r = 12 : r > 12 && (r -= 12, o = n.pm);
  const i = `${r}:${a(e.getMinutes())}`;
  return t ? `${i}:${a(e.getSeconds())} ${o}` : `${i} ${o}`;
}
function je(e, t) {
  t ?? (t = { dayShorthand: "d", hourShorthand: "h", remainingTemplate: "{{value}} remaining" });
  const { days: n, hours: r, minutes: o, seconds: i } = V(Math.abs(e));
  let s = "";
  return n > 0 ? s = `${n}${t.dayShorthand} ${r}${t.hourShorthand}` : r > 0 ? s = `${r}:${a(o)}:${a(i)}` : s = `${o}:${a(i)}`, e < 0 ? t.remainingTemplate.replace("{{value}}", s) : s;
}
function ze(e, t) {
  t ?? (t = { dayShorthand: "d", hourShorthand: "h", minuteShorthand: "m", secondShorthand: "s", remainingTemplate: "{{value}} remaining" });
  const { days: n, hours: r, minutes: o, seconds: i } = V(Math.abs(e));
  let s = "";
  return n > 0 ? s = `${n}${t.dayShorthand} ${r}${t.hourShorthand}` : ((e === 0 || i !== 0) && (s = `${i}${t.secondShorthand}`), o > 0 && (s = `${o}${t.minuteShorthand}${s ? " " : ""}${s}`), r > 0 && (s = `${r}${t.hourShorthand}${s ? " " : ""}${s}`)), e < 0 ? t.remainingTemplate.replace("{{value}}", s) : s;
}
const oe = k(Q)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
function He({ component: e, noFallback: t, ...n }) {
  return /* @__PURE__ */ h(F, { fallback: t ? null : /* @__PURE__ */ h(oe, {}), children: /* @__PURE__ */ h(e, { ...n }) });
}
const se = 8, w = { loading: "Loading" }, C = _.getDesignToken();
function ie({ children: e, itemKey: t, innerRef: n, scrollableDivRef: r, rootMargin: o = se, translations: i = w, theme: s }) {
  const c = d(null), [g, f] = te({ width: 0, height: window.innerHeight }, `VirtualListItem-${t}`), [u, l] = Z(g), [p, N] = $(!1);
  m(
    () => {
      if (t)
        return () => f(u);
    },
    [u, p, t, f]
  ), m(
    () => {
      if (!c.current || !r.current)
        return;
      const A = (S) => {
        N(S[0].isIntersecting);
      }, L = new IntersectionObserver(A, { root: r.current, rootMargin: `${o}px` });
      L.observe(c.current);
      const J = (S) => {
        var R;
        (R = c.current) != null && R.offsetParent && l({ width: S[0].contentRect.width, height: S[0].contentRect.height });
      }, P = new ResizeObserver(J);
      return P.observe(c.current), () => {
        L.disconnect(), P.disconnect();
      };
    },
    [t, o, r, l]
  );
  const O = D(
    () => N(ae(r.current, c.current, o)),
    [o, r]
  );
  return typeof n == "function" ? n({ correctIntersectionIfNeeded: O }) : n.current = { correctIntersectionIfNeeded: O }, /* @__PURE__ */ h(ce, { ref: c, $theme: s, children: p ? e : /* @__PURE__ */ K(ue, { style: u, $theme: s, children: [
    (i == null ? void 0 : i.loading) ?? (w == null ? void 0 : w.loading),
    "..."
  ] }) });
}
const ce = k.div`
  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  animation: appear ${(e) => (e.$theme ?? C).motionDurationMid} ${(e) => (e.$theme ?? C).motionEaseInOut};
`, ue = k.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${(e) => (e.$theme ?? C).colorTextPlaceholder};
`;
function ae(e, t, n = 0) {
  if (!e || !t)
    return !0;
  const r = e.getBoundingClientRect(), o = t.getBoundingClientRect();
  return !(r.top - n > o.bottom || r.right - n < o.left || r.bottom + n < o.top || r.left + n > o.right);
}
function Ue({ getItemKey: e, scrollableDivRef: t, rootMargin: n, translations: r, theme: o, renderItem: i, ...s }) {
  var g;
  const c = d(new Array(((g = s.dataSource) == null ? void 0 : g.length) ?? 0));
  return m(
    () => {
      if (!t.current)
        return;
      async function f() {
        await new Promise((l) => setTimeout(l, 100)), c.current.forEach((l) => l.correctIntersectionIfNeeded());
      }
      const u = t.current;
      return u.addEventListener("scrollend", f), () => {
        u.removeEventListener("scrollend", f);
      };
    },
    [t]
  ), /* @__PURE__ */ h(
    G,
    {
      ...s,
      renderItem: i && ((f, u) => /* @__PURE__ */ h(F, { fallback: null, children: /* @__PURE__ */ h(
        ie,
        {
          itemKey: e(f, u),
          innerRef: (l) => c.current[u] = l,
          scrollableDivRef: t,
          rootMargin: n,
          translations: r,
          theme: o,
          children: i(f, u)
        }
      ) }, e(f, u)))
    }
  );
}
X("shared-frontend-utilities", "20250114.2", "1.5.6");
export {
  $e as ConversationContext,
  M as DAY,
  I as HOUR,
  pe as HostContext,
  y as MINUTE,
  He as Suspended,
  Ue as VirtualList,
  Se as WorkItemContext,
  V as breakDownSeconds,
  Ye as capitalize,
  xe as defaultCustomer,
  De as formatDateDefault,
  Ne as formatDateEU,
  ke as formatDateISO,
  Oe as formatDateUS,
  Le as formatDateWritten,
  Te as formatTime12Hour,
  Re as formatTime24Hour,
  Pe as formatTimeDefault,
  je as formatTimeSpanNormal,
  ze as formatTimeSpanWritten,
  Me as getCustomerFullName,
  Ce as getCustomerPrimaryPhone,
  Ee as getItem,
  x as inMemoryStorage,
  Be as isEmptyObject,
  We as mapObject,
  re as setItem,
  X as setVersionInfo,
  qe as sortByProperty,
  Ke as toTitleCase,
  we as useAsyncMemo,
  Z as useLazyUpdateState,
  ye as useLiveCounter,
  Ie as useMediaQuery,
  te as usePersistedState,
  ve as usePureEffect,
  be as useStateChangeCallbacks,
  Ae as useSubscriptionHandler
};
//# sourceMappingURL=index.js.map
